import { Chip } from '@/components/common'
import { cn } from '@/services/utils/cn'

function TimelineImageItem({
  disabled,
  title,
  description,
  durationText,
}: {
  disabled?: boolean
  title: string
  description: string
  durationText: string
}) {
  return (
    <div className="flex gap-4 px-4 font-line">
      <div
        className={cn(
          'mt-1.5 h-2 w-2 shrink-0 rounded-full',
          disabled ? 'bg-zinc-400' : 'bg-sky-500'
        )}
      />
      <div
        className={cn(
          'h-20 w-16 shrink-0 rounded-xl bg-[#808080]',
          disabled ? 'opacity-50' : 'opacity-100'
        )}
      />
      <div className="flex flex-col gap-1">
        <h3
          className={cn(
            'text-sm text-zinc-950',
            disabled ? 'font-normal' : 'font-bold'
          )}
        >
          {title}
        </h3>
        <p className="text-wrap text-[10px] font-normal text-neutral-500 md:text-balance">
          {description}
        </p>
        <p className="text-[10px] font-normal text-neutral-500">
          {durationText}
        </p>
      </div>
    </div>
  )
}

function TimelineTextItem({
  disabled,
  title,
  durationText,
}: {
  disabled?: boolean
  title: string
  durationText: string
}) {
  return (
    <div className="flex gap-4 px-4 font-line">
      <div
        className={cn(
          'mt-1.5 h-2 w-2 shrink-0 rounded-full',
          disabled ? 'bg-zinc-400' : 'bg-sky-500'
        )}
      />
      <div className="flex w-full flex-col font-normal">
        <div className="flex w-full items-center justify-between">
          <p
            className={cn(
              'text-sm text-zinc-950',
              disabled ? 'font-normal' : 'font-bold'
            )}
          >
            {title}
          </p>
          <Chip name="แนะนำ" className="mt-0" />
        </div>
        <p className="text-xs text-zinc-400">{durationText}</p>
      </div>
    </div>
  )
}

export { TimelineImageItem, TimelineTextItem }
